import React, { useEffect, useState } from "react";
import { db, auth } from "../../firebase";
import emailjs from '@emailjs/browser'; // MUST IMPORT THIS
import {
  collection,
  query,
  where,
  getDocs,
  updateDoc,
  orderBy,
  doc,
  getDoc,
  deleteDoc,
} from "firebase/firestore";
import { useNavigate } from "react-router-dom";
import { saveAs } from "file-saver";
import Verify from "../../assets/verified.svg";
import ChatAssistance from "../../assets/OnboardingCards/HelpLoverr.svg";
import BackArrow from "../../assets/goBackarrow.svg";
import "./AdminReview.css";

const AdminReview = () => {
  const [users, setUsers] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    const checkAdmin = async () => {
      try {
        const userDoc = await getDoc(doc(db, "users", auth.currentUser.uid));
        if (userDoc.exists() && userDoc.data().role !== "admin") {
          navigate("/");
        }
      } catch (error) {
        console.error("Error checking admin role:", error);
      }
    };

    const fetchUsers = async () => {
      try {
        const q = query(
          collection(db, "users"),
          where("status", "==", "pending"),
          orderBy("createdAt", "desc"),
        );
        const querySnapshot = await getDocs(q);

        const userPromises = querySnapshot.docs.map(async (userDoc) => {
          const userData = userDoc.data();
          const userEmail = userData.email;

          const verificationQuery = query(
            collection(db, "verifications"),
            where("email", "==", userEmail),
          );

          const verificationSnapshot = await getDocs(verificationQuery);

          const baseUserData = {
            id: userDoc.id,
            firstName: userData.firstName || "",
            lastName: userData.lastName || "",
            email: userData.email || "",
            status: userData.status || "",
            phone: userData.phone || "No Phone",
            picturee: userData.profilePicture,
            createdAt: userData.createdAt?.toDate
              ? userData.createdAt.toDate()
              : null,
          };

          if (!verificationSnapshot.empty) {
            const verificationData = verificationSnapshot.docs[0].data();
            return {
              ...baseUserData,
              photoURL: verificationData.photoURL,
              idCardURL: verificationData.idCardURL,
            };
          }

          return baseUserData;
        });

        const usersList = await Promise.all(userPromises);
        setUsers(usersList);
      } catch (error) {
        console.error("Error fetching users:", error);
      }
    };

    checkAdmin();
    fetchUsers();
  }, [navigate]);

  // const handleApprove = async (userId) => {
  //   try {
  //     await updateDoc(doc(db, "users", userId), { status: "approved" });
  //     setUsers(users.filter((user) => user.id !== userId));
  //   } catch (error) {
  //     console.error("Error approving user:", error);
  //   }
  // };


  const handleApprove = async (userId) => {
    try {
      const userToApprove = users.find(u => u.id === userId);
      
      if (!userToApprove) {
        alert("User data not found!");
        return;
      }

      await updateDoc(doc(db, "users", userId), { status: "approved" });

      const templateParams = {
        to_email: userToApprove.email,
        user_name: userToApprove.firstName,
        message: "Your profile has been approved! You can now chat with other members.",
        login_link: "https://ikorodu-dating-site.vercel.app/"
      };

      await emailjs.send(
        'service_8f9b4v4', 
        'template_7gapo0l', 
        templateParams, 
        'wHCP3NvFISMB-iTZT'
      );

      setUsers(users.filter((u) => u.id !== userId));
      alert(`User ${userToApprove.firstName} approved and email sent!`);
      
    } catch (error) {
      console.error("Error approving user:", error);
      alert("Error: " + error.message);
    }
  };

  const handleReject = async (userId) => {
    try {
      await updateDoc(doc(db, "users", userId), { status: "rejected" });
      setUsers(users.filter((user) => user.id !== userId));
    } catch (error) {
      console.error("Error rejecting user:", error);
    }
  };

  const handleDelete = async (userId) => {

    try {
      await deleteDoc(doc(db, "users", userId));
      setUsers(users.filter((user) => user.id !== userId));
    } catch (error) {
      console.error("Error deleting user:", error);
    }
  };

  const generateCSV = () => {
    const headers = "First Name,Email,Phone,Date Joined\n";
    const rows = users
      .map((user) => {
        const dateStr = user.createdAt
          ? user.createdAt.toLocaleDateString()
          : "N/A";
        return `${user.firstName},${user.email},${user.phone},${dateStr}`;
      })
      .join("\n");

    const csvContent = headers + rows;
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    saveAs(blob, "user_data_export.csv");
  };

  const filteredUsers = users.filter(
    (user) =>
      user.firstName.toLowerCase().includes(searchTerm.toLowerCase()) ||
      user.email.toLowerCase().includes(searchTerm.toLowerCase()),
  );

  return (
    <div className="admin-review">
      <div style={{ paddingTop: 16 }} className="onboardingBackBTN">
        <button onClick={() => navigate(-1)}>
          <img src={BackArrow} alt="back button" />
        </button>
        <p
          style={{
            fontSize: 18,
            fontWeight: "600",
            color: "#e91e63",
            alignItems: "center",
            display: "flex",
            gap: 6,
          }}
        >
          Admin Review Page <img style={{ width: 15 }} src={Verify} alt="" />
        </p>
        <button onClick={() => navigate("/help")}>
          <img src={ChatAssistance} alt="back button" />
        </button>
      </div>
      <input
        type="text"
        placeholder="Search by name or email"
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        className="search-box"
      />
      {filteredUsers.length === 0 ? (
        <p>No users found</p>
      ) : (
        <div className="ulReview">
          <ul>
            {filteredUsers.map((user) => (
              <li key={user.id}>
                <p>Email: {user.email}</p>
                <p>
                  Name: {user.firstName} {user.lastName}
                </p>
                <p>
                  <strong>Phone:</strong> {user.phone}
                </p>
                <p>
                  <strong>Joined:</strong>{" "}
                  {user.createdAt
                    ? user.createdAt.toLocaleDateString()
                    : "Unknown"}
                </p>
                <p>
                  <strong>Status:</strong> {user.status}
                </p>
                {user.picturee && (
                  <img
                    src={user.picturee}
                    alt="iPhoto"
                    style={{
                      width: "140px",
                      height: "200px",
                      objectFit: "cover", // This keeps the face from looking stretched
                      borderRadius: "8px",
                    }}
                  />
                )}
                {user.photoURL && (
                  <img
                    src={user.photoURL}
                    alt="iPhoto"
                    style={{
                      width: "140px",
                      height: "200px",
                      objectFit: "cover", // This keeps the face from looking stretched
                      borderRadius: "8px",
                    }}
                  />
                )}
                {user.idCardURL && (
                  <img
                    src={user.idCardURL}
                    alt="ID Card"
                    style={{
                      width: "140px",
                      height: "200px",
                      objectFit: "cover", // This keeps the face from looking stretched
                      borderRadius: "8px",
                    }}
                  />
                )}
                <button onClick={() => handleApprove(user.id)}>Approve</button>
                <button
                  className="reject"
                  onClick={() => handleReject(user.id)}
                >
                  Reject
                </button>
                <button
                  className="delete"
                  onClick={() => handleDelete(user.id)}
                >
                  Delete
                </button>{" "}
                {/* New Delete Button */}
              </li>
            ))}
          </ul>
          <button className="odelee" onClick={generateCSV}>
            Download CSV
          </button>
        </div>
      )}
    </div>
  );
};

export default AdminReview;
